import styled from "@emotion/native"
import ArrowBackIcon from "../assets/ArrowBack2.svg"
import { useNavigation } from "@react-navigation/native"

type BackArrowProps = {
  onPress?: () => void
  backgroundColor?: string
}

export function BackArrow(props: BackArrowProps) {
  const { onPress, backgroundColor } = props

  const navigation = useNavigation()

  const handleBackPress = () => {
    if (onPress) {
      onPress()
      return
    }

    navigation.goBack()
  }

  return (
    <ArrowContainer onPress={handleBackPress} backgroundColor={backgroundColor}>
      <ArrowBackIcon />
    </ArrowContainer>
  )
}

const ArrowContainer = styled.Pressable<{ backgroundColor?: string }>`
  padding: 8px;
  border-radius: 100px;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.backArrow.background};
  width: 40px;
  height: 40px;
`
